export const AUTH_TOKEN = '@market-place-auth-token'
export const USER_TOKEN = '@market-place-user-token'
